import React, { useCallback, useState } from 'react';
import { useProviderHelpers } from './ProviderHelpers';
import * as constants from '../../constants';

const Context = React.createContext();

export const TransactionDocumentLookupsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const [documentEditerTab, setDocumentEditerTab] = useState(constants.DOCUMENT_EDIT_SETUP.Info);
    const [documentCategoryKey, setDocumentCategoryKey] = useState(constants.DOCUMENT_CATEGORY.Transaction);
    const [transactionTypeKey, setTransactionTypeKey] = useState();
    const [statusKey, setStatusKey] = useState(constants.DEFAULT_STATUS_KEY);
    const [prospectsStatusKey, setProspectsStatusKey] = useState(constants.DEFAULT_STATUS_KEY);
    const [franchiseTabKey, setFranchiseTabKey] = useState(constants.DEFAULT_FRANCHISE_TAB);
    const [documentTypeKey, setDocumentTypeKey] = useState();
    const [franchiseInstance, setFranchiseInstance] = useState();

    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: 'TransactionDocumentSetup/GetTransactionTypes/', method: 'GET', secure: true });
    }, [execute]);

    const getLookupData = useCallback(async (props) => {
        await execute({ scope: 'select', url: `TransactionDocumentSetup/GetLookupData/${props.type}/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const getSmartDocMapperToken = useCallback(async (props) => {
        await execute({ scope: 'mapperToken', url: `TransactionDocumentSetup/GetSmartDocMapperToken`, method: 'GET', secure: true });
    }, [execute]);

    const value = {
        listRecords, getLookupData, data, clearData, documentEditerTab, setDocumentEditerTab,
        documentCategoryKey, setDocumentCategoryKey, transactionTypeKey, setTransactionTypeKey,
        statusKey, setStatusKey, prospectsStatusKey, setProspectsStatusKey, franchiseTabKey, setFranchiseTabKey,
        documentTypeKey, setDocumentTypeKey, franchiseInstance, setFranchiseInstance, getSmartDocMapperToken
    };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useTransactionDocumentLookupsStore = () => React.useContext(Context);
